import { Form, Radio } from 'antd';
import { DownVote, UpVote } from '../assets/svg';
import { VoteEnum } from '../types/common.type';

const FeedbackVoteFormItem: React.FC<{
  onChange: (e: VoteEnum) => void;
  vote: VoteEnum;
  label: string;
  name: string;
}> = ({ onChange, vote, label, name }) => {
  const isUp = vote === VoteEnum.UpVote;
  const isDown = vote === VoteEnum.DownVote;

  const toggle = (against: VoteEnum) =>
    vote === against
      ? () => {
          onChange?.(VoteEnum.NoVote);
        }
      : undefined;

  return (
    <Form.Item label={<b>{label} </b>} name={name}>
      <Radio.Group
        value={vote}
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
      >
        <Radio.Button
          value={VoteEnum.UpVote}
          className={`${isUp ? 'up-vote' : ''}`}
          onClick={toggle(VoteEnum.UpVote)}
        >
          <UpVote />
        </Radio.Button>
        <Radio.Button
          value={VoteEnum.DownVote}
          className={`${isDown ? 'down-vote' : ''}`}
          onClick={toggle(VoteEnum.DownVote)}
        >
          <DownVote />
        </Radio.Button>
      </Radio.Group>
    </Form.Item>
  );
};

export default FeedbackVoteFormItem;
